<!-- <template>
  <section class="locations">
    <div class="locations-container">
      <div class="locations-content">
        <div class="content-item">
          <div class="background-icon">
            <i class="fa fa-map-marker"></i>
          </div>
          <router-link :to="{ name: $t('locationsRouteName') }">
            <h2 class="content-title">{{ $t("locations") }}</h2>
          </router-link>
        </div>

        <div class="content-item">
          <div class="background-icon">
            <i class="fa fa-question"></i>
          </div>
          <router-link :to="{ name: 'anketa' }">
            <h2 class="content-title">{{ $t("survey") }}</h2>
          </router-link>
        </div>

        <div class="content-item">
          <div class="background-icon">
            <i class="fa fa-envelope-o"></i>
          </div>
          <router-link :to="{ name: $t('contactRouteName') }">
            <h2 class="content-title">{{ $t("Contact") }}</h2>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LocationsSection'
}
</script>

<style scoped>
.locations {
  background-color: var(--light-color);
  padding: 1% 0;
}

.locations-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 7% !important;
  display: flex;
  gap: 1.7rem;
  justify-content: space-between;
}

.locations-content {
  width: 100%;
  background-color: var(--secondary-color);
  border-radius: 20px;
  padding: 30px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  gap: 20px;
}

.content-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  background-color: var(--light-color);
  border-radius: 15px;
  padding: 25px;
  height: 100%;
  box-shadow: 0 6px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;
  width: 100%;
}

.content-item:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.content-title {
  font-size: 24px;
  color: var(--main-color);
  font-weight: 600;
  margin: 0;
  flex: 1;
  padding-bottom: 0;
}

.background-icon {
  position: absolute;
  right: 10px;
  top: 0px;
  font-size: 40px;
  opacity: 0.1;
  color: var(--main-color);
  transform: rotate(10deg);
  transition: all 0.5s ease;
}

.content-item:hover .background-icon {
  transform: rotate(15deg) scale(1.3);
  opacity: 0.2;
}

@media (max-width: 1024px) {
  .locations-container {
    flex-direction: column;
    gap: 2rem;
  }

  .locations-content {
    flex-direction: column;
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .locations {
    padding: 2rem 0;
  }

  .locations-container {
    padding: 0 1.5rem;
  }

  .locations-content {
    padding: 1rem;
  }

  .content-title {
    font-size: 1.3rem;
  }

  .content-button {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .locations {
    padding: 2rem 0;
  }

  .locations-container {
    padding: 0 1rem;
    gap: 1.5rem;
  }

  .locations-content {
    padding: 1rem;
  }

}
</style> -->

<template>
  <section class="locations">
    <div class="locations-container">

      <!-- Left part -->
      <div class="left-panel">
        <div class="left-text">
          <h3 class="left-title">{{ $t("findUsTitle") }}</h3>
          <p class="left-subtitle">{{ $t("findUsSubtitle") }}</p>
        </div>

        <router-link :to="{ name: $t('locationsRouteName') }" class="icon-card">
          <i class="fa fa-map-marker icon-card__icon"></i>
          <span class="icon-card__label">{{ $t("locations") }}</span>
        </router-link>

        <router-link :to="{ name: 'anketa' }" class="icon-card">
          <i class="fa fa-question-circle icon-card__icon"></i>
          <span class="icon-card__label">{{ $t("survey") }}</span>
        </router-link>
      </div>

      <!-- Right part: icon LEFT, text+cta RIGHT -->
      <div class="right-panel">
        <div class="right-panel__left">
          <i class="fa fa-headphones right-panel__icon"></i>
        </div>
        <div class="right-panel__right">
          <h3 class="right-panel__title">{{ $t("needHelp") }}</h3>
          <p class="right-panel__subtitle">{{ $t("helpSubtitle") }}</p>
          <router-link :to="{ name: $t('contactRouteName') }" class="cta-btn">
            {{ $t("Contact") }} →
          </router-link>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'LocationsSection'
}
</script>

<style scoped>
.locations {
  background-color: var(--light-color, #f0f4fb);
  padding: 3rem 7%;

}

.locations-container {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  gap: 1rem;
  align-items: stretch;
}

/* ── LEFT PANEL ── */
.left-panel {
  flex: 2;
  background-color: #e8edf7;
  border-radius: 16px;
  padding: 28px 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.left-text {
  flex: 1;
  min-width: 160px;
}

.left-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--main-color, #1a3c6b);
  margin: 0 0 8px 0;
}

.left-subtitle {
  font-size: 18px;
  color: #5a6e8c;
  margin: 0;
  line-height: 1.5;
}

/* Icon cards */
.icon-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: #ffffff;
  border-radius: 14px;
  padding: 28px 36px;
  text-decoration: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  min-width: 130px;
}

.icon-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.icon-card__icon {
  font-size: 34px;
  color: var(--main-color, #1a3c6b);
}

.icon-card__label {
  font-size: 18px;
  font-weight: 600;
  color: var(--main-color, #1a3c6b);
  white-space: nowrap;
}

/* ── RIGHT PANEL ── */
.right-panel {
  flex: 1;
  background: linear-gradient(120deg, #2d6fc7 0%, #1e4fa3 45%, #163d85 100%);
  border-radius: 16px;
  padding: 28px 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.right-panel::before {
  content: '';
  position: absolute;
  top: -40px;
  right: -40px;
  width: 180px;
  height: 180px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 50%;
  pointer-events: none;
}

.right-panel::after {
  content: '';
  position: absolute;
  bottom: -20px;
  right: 60px;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  pointer-events: none;
}

.right-panel__left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.right-panel__icon {
  font-size: 42px;
  color: rgba(255, 255, 255, 0.85);
}

.right-panel__right {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}

.right-panel__title {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.right-panel__subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  line-height: 1.4;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 24px;
  background-color: #ffffff;
  color: #1a3c6b;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  align-self: flex-start;
  margin-top: 6px;
  transition: background-color 0.2s ease;
}

.cta-btn:hover {
  background-color: rgba(255, 255, 255, 0.88);
}

/* ── Responsive ── */
@media (max-width: 1100px) {
  .icon-card {
    padding: 22px 24px;
    min-width: 110px;
  }
}

@media (max-width: 900px) {
  .locations-container {
    flex-direction: column;
  }

  .right-panel {
    flex-direction: row;
  }
}

@media (max-width: 480px) {
  .locations {
    padding: 1.5rem 1rem;
  }

  .left-panel {
    flex-direction: column;
    align-items: flex-start;
  }

  .icon-card {
    width: 100%;
  }

  .right-panel {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>